import { Box, Dialog, useMediaQuery, useTheme } from '@mui/material';
import React, { useId } from 'react';

import { DIALOG_BODY_SX, DIALOG_PAPER_SX, TAB_SX, TABS_SX } from './reportEditDialog.styles';
import { ReportEditDialogHeader } from './ReportEditDialogHeader';
import { ReportEditFragmentProps } from './ReportEditFragment.props';
import { useReportEditDialogData } from './useReportEditDialogData';
import { Tabs, TextColorProps } from '../../../../../components/molecules/Tabs';
import { ReportShareTabs } from '../../../../../configs/enums';
import { ReportSettingsFragment } from '../ReportSettingsFragment';
import { ScheduleEmailFragment } from '../ScheduleEmail/ScheduleEmailFragment';
import { ShareAccessWithFragment } from '../ShareAccessWithFragment';

export const ReportEditFragment: React.FC<ReportEditFragmentProps> = ({
  open,
  closeModel,
  rowData,
  refetchReports,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const titleId = useId();

  const dialog = useReportEditDialogData(open, refetchReports, rowData);

  return (
    <>
      <Dialog
        open={open}
        onClose={closeModel}
        fullScreen={fullScreen}
        aria-labelledby={titleId}
        slotProps={{ paper: { sx: DIALOG_PAPER_SX } }}
      >
        <ReportEditDialogHeader
          title="Share & Schedule Report"
          titleId={titleId}
          subtitle={rowData?.name}
          onClose={closeModel}
        />
        <Box sx={DIALOG_BODY_SX}>
          {dialog.visibleTabs.length > 0 && (
            <Tabs
              name="report-share-method-tabs"
              tabTitles={dialog.visibleTabs}
              textColor={TextColorProps.Inherit}
              isCustomColor={false}
              sx={TABS_SX}
              tabSx={TAB_SX}
              TabIndicatorProps={{
                sx: { backgroundColor: theme.palette.v4.accentDark, height: 2 },
              }}
              onTabChange={(tabType: string) =>
                tabType === ReportShareTabs.DirectShare && dialog.refetchShareAccess()
              }
            >
              {dialog.canShare && (
                <ShareAccessWithFragment
                  rowData={rowData}
                  savedData={dialog.shareAccessData}
                  handleRefetch={dialog.handleRefetch}
                />
              )}
              {dialog.canSchedule && (
                <ScheduleEmailFragment
                  attachmentTypes={dialog.attachmentTypes}
                  reportId={rowData?.id}
                  handleRefetch={dialog.handleRefetch}
                />
              )}
              {dialog.canEditSettings && rowData && (
                <ReportSettingsFragment
                  reportCode={rowData.code}
                  permissions={dialog.permissions}
                />
              )}
            </Tabs>
          )}
        </Box>
      </Dialog>
    </>
  );
};
